<template>
  <q-tab-panel :class="['tabPanel', { 'paddingless': this.paddingless }]" :name="this.name">
    <slot></slot>
  </q-tab-panel>
</template>

<script>
export default {
  name: "CustomTabPanel",
  props: {
    name: String,
    paddingless: Boolean,
  },
}
</script>

<style scoped lang="scss">
.tabPanel {
  &.paddingless {
    padding: 0;
  }
}
</style>
